import { fetchCurrentHeader } from './BuilderRoot'
import { getOriginalId, customItemsSeparator } from './helpers'
import nanoid from 'nanoid'

export const builderReducer = (builderValue, action) => {
	let updatedGlobalState = {}
	let newSections = []

	let futureBuilderValue = builderValue.sections.find(
		({ id }) =>
			id.indexOf(
				builderValue.__forced_static_header__ ||
					fetchCurrentHeader() ||
					builderValue.sections[0].id
			) > -1
	)

	let shouldUpdate = false
	let updateItemId = false
	let removeSectionIds = []

	if (action.type === 'ITEM_VALUE_ON_CHANGE') {
		const { id, optionId, optionValue, values = {} } = action.payload

		updateItemId = `${id}:${optionId}`

		let items = futureBuilderValue.items

		if (!items.find(({ id: _id }) => _id === id)) {
			items = [
				...items,
				{
					id,
					values: {},
				},
			]
		}

		futureBuilderValue = {
			...futureBuilderValue,
			items: items.map((item) =>
				item.id === id
					? {
							...item,
							values: {
								...item.values,
								...values,
								[optionId]: optionValue,
							},
					  }
					: item
			),
		}
	}

	if (action.type === 'PICK_BUILDER_SECTION') {
		shouldUpdate = true
		updatedGlobalState = {
			__forced_static_header__: action.payload.id,
		}
	}

	if (action.type === 'MARK_HEADER_AS_GLOBAL') {
		shouldUpdate = true
		updatedGlobalState = {
			current_section: builderValue.__forced_static_header__,
		}
	}

	if (action.type === 'MARK_SPECIFIC_HEADER_AS_GLOBAL') {
		updatedGlobalState = {
			current_section: action.payload.id,
		}
	}

	if (action.type === 'CLONE_ITEM') {
		const futureId = getOriginalId(action.payload.id)

		futureBuilderValue = {
			...futureBuilderValue,
			items: [
				...futureBuilderValue.items,
				{
					id: `${futureId}${customItemsSeparator()}${nanoid()}`,
					values: futureBuilderValue.items.find(
						({ id }) => id === futureId
					)
						? futureBuilderValue.items.find(
								({ id }) => id === futureId
						  ).values
						: {},
				},
			],
		}
	}

	if (action.type === 'REMOVE_CLONED_ITEM') {
		futureBuilderValue = {
			...futureBuilderValue,
			items: futureBuilderValue.items.filter(
				({ id }) => id !== action.payload.id
			),
		}
	}

	if (action.type === 'SET_LIST') {
		shouldUpdate = true
		const { currentView, lists } = action.payload

		if (
			/**
			 * If we just inserted offcanvas trigger on desktop
			 */
			currentView === 'desktop' &&
			Object.values(lists)
				.reduce((all, current) => [...all, ...current], [])
				.indexOf('trigger') > -1 &&
			!futureBuilderValue.desktop.find(({ id }) => id === 'offcanvas')
		) {
			futureBuilderValue = {
				...futureBuilderValue,
				desktop: [
					...futureBuilderValue.desktop,
					{
						id: 'offcanvas',
						placements: [
							{
								id: 'start',
								items: [],
							},
						],
					},
				],
			}
		}

		futureBuilderValue = {
			...futureBuilderValue,
			[currentView]: futureBuilderValue[currentView].map(
				({ id: barId, placements }) => {
					const keys = Object.keys(lists)

					if (keys.map((k) => k.split(':')[0]).indexOf(barId) > -1) {
						let futureBar = {
							id: barId,
							placements: placements.map(({ id, items }) => {
								if (lists[`${barId}:${id}`]) {
									return {
										id,
										items: lists[`${barId}:${id}`],
									}
								}

								return { id, items }
							}),
						}

						if (
							futureBar.placements.find(
								({ id }) => id === 'middle'
							) &&
							futureBar.placements.find(
								({ id }) => id === 'middle'
							).items.length === 0 &&
							futureBar.placements.find(
								({ id }) => id === 'start-middle'
							) &&
							(futureBar.placements.find(
								({ id }) => id === 'start-middle'
							).items.length > 0 ||
								futureBar.placements.find(
									({ id }) => id === 'end-middle'
								).items.length > 0)
						) {
							let updater = {}

							updater[`${barId}:start`] = [
								...futureBar.placements.find(
									({ id }) => id === 'start'
								).items,
								...futureBar.placements.find(
									({ id }) => id === 'start-middle'
								).items,
							]

							updater[`${barId}:end`] = [
								...futureBar.placements.find(
									({ id }) => id === 'end-middle'
								).items,
								...futureBar.placements.find(
									({ id }) => id === 'end'
								).items,
							]

							updater[`${barId}:start-middle`] = []
							updater[`${barId}:end-middle`] = []

							futureBar = {
								id: barId,
								placements: futureBar.placements.map(
									({ id, items }) => {
										if (updater[`${barId}:${id}`]) {
											return {
												id,
												items:
													updater[`${barId}:${id}`],
											}
										}

										return { id, items }
									}
								),
							}
						}

						return futureBar
					}

					return {
						id: barId,
						placements,
					}
				}
			),
		}
	}

	if (action.type === 'BUILDER_GLOBAL_SETTING_ON_CHANGE') {
		const { optionId, optionValue, values = {} } = action.payload

		futureBuilderValue = {
			...futureBuilderValue,
			settings: {
				...futureBuilderValue.settings,
				...values,
				[optionId]: optionValue,
			},
		}
	}

	if (action.type === 'CREATE_NEW_SECTION') {
		const { name, copy } = action.payload

		newSections = [
			copy
				? {
						...(builderValue.sections.find(
							({ id }) => id === copy
						) || {}),

						name,
						id: `ct-custom-${nanoid()}`,
				  }
				: {
						name,
						id: `ct-custom-${nanoid()}`,
						mode: 'placements',
						items: [],
						settings: [],
						desktop: [
							{
								id: 'top-row',
								placements: [
									{
										id: 'start',
										items: [],
									},
									{
										id: 'middle',
										items: [],
									},
									{
										id: 'end',
										items: [],
									},
									{
										id: 'start-middle',
										items: [],
									},
									{
										id: 'end-middle',
										items: [],
									},
								],
							},

							{
								id: 'middle-row',
								placements: [
									{
										id: 'start',
										items: ['logo'],
									},
									{
										id: 'middle',
										items: [],
									},
									{
										id: 'end',
										items: ['menu'],
									},
									{
										id: 'start-middle',
										items: [],
									},
									{
										id: 'end-middle',
										items: [],
									},
								],
							},
							{
								id: 'bottom-row',
								placements: [
									{
										id: 'start',
										items: [],
									},
									{
										id: 'middle',
										items: [],
									},
									{
										id: 'end',
										items: [],
									},
									{
										id: 'start-middle',
										items: [],
									},
									{
										id: 'end-middle',
										items: [],
									},
								],
							},
						],

						mobile: [
							{
								id: 'top-row',
								placements: [
									{
										id: 'start',
										items: [],
									},
									{
										id: 'middle',
										items: [],
									},
									{
										id: 'end',
										items: [],
									},
									{
										id: 'start-middle',
										items: [],
									},
									{
										id: 'end-middle',
										items: [],
									},
								],
							},

							{
								id: 'middle-row',
								placements: [
									{
										id: 'start',
										items: ['logo'],
									},
									{
										id: 'middle',
										items: [],
									},
									{
										id: 'end',
										items: ['trigger'],
									},
									{
										id: 'start-middle',
										items: [],
									},
									{
										id: 'end-middle',
										items: [],
									},
								],
							},

							{
								id: 'bottom-row',
								placements: [
									{
										id: 'start',
										items: [],
									},
									{
										id: 'middle',
										items: [],
									},
									{
										id: 'end',
										items: [],
									},
									{
										id: 'start-middle',
										items: [],
									},
									{
										id: 'end-middle',
										items: [],
									},
								],
							},

							{
								id: 'offcanvas',
								placements: [
									{
										id: 'start',
										items: ['mobile-menu'],
									},
								],
							},
						],
				  },
		]
	}

	if (action.type === 'REMOVE_BUILDER_SECTION') {
		removeSectionIds.push(action.payload.id)
	}

	const actualBuilderValue = {
		...builderValue,
		...updatedGlobalState,
		__should_refresh__: shouldUpdate,
		__should_refresh_item__: updateItemId,
		sections: [
			...builderValue.sections.map((builder) =>
				builder.id === futureBuilderValue.id
					? futureBuilderValue
					: builder
			),
			...newSections,
		].filter(({ id }) => removeSectionIds.indexOf(id) === -1),
	}

	return actualBuilderValue
}
